import {
	MenuBuilder
} from './MenuBuilder'
import {
	MobileButtonBuilder
} from './MobileButtonBuilder'
import {
	ResizeObserver
} from './ResizeObserver'

(async () => {

	const resizeObserver = new ResizeObserver(1200)

	const menuBuilder = new MenuBuilder(resizeObserver)
	window.menu = await menuBuilder.build('[data-navbar-content]')

	const menuButtonBuilder = new MobileButtonBuilder(window.menu)
	window.menuButton = menuButtonBuilder.build('[data-navbar-button]')
	const tables = [...document.querySelectorAll('.table-scroll table,.overlay-content')]

	if (tables) {
		tables.forEach(table => table.addEventListener('touchstart', e => e.stopPropagation()))
	}
	const submenuOpenHandler = submenu => {
		if (!window.menu.isMobile) return false
		document.querySelector('.menu-items').classList.add('submenu-down')
		const submenuNode = submenu.node.querySelector('.submenu')
		const subitemsNodes = submenuNode.querySelectorAll('.subitem')
		const subitemstTotalHeight = subitemsNodes.length * subitemsNodes[0].offsetHeight
		submenuNode.style.height = `${subitemstTotalHeight}px`
	}

	const submenuCloseHandler = submenu => {
		if (!window.menu.isMobile) return false
		document.querySelector('.menu-items').classList.remove('submenu-down')
		const submenuNode = submenu.node.querySelector('.submenu')
		submenuNode.style.height = '0px'
	}

	window.menu.submenus.map(submenu => {
		submenu.on('before:open', submenuOpenHandler)
		submenu.on('before:close', submenuCloseHandler)
	})
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/script.js